import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64ddca2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portal-home-project" }
const _hoisted_2 = { class: "portal-home-project-main" }
const _hoisted_3 = { class: "portal-home-project-title" }
const _hoisted_4 = { class: "portal-home-project-actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("进入 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("置顶 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消置顶")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloudServerOutlined = _resolveComponent("CloudServerOutlined")!
  const _component_HomeStatus = _resolveComponent("HomeStatus")!
  const _component_ImportOutlined = _resolveComponent("ImportOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_VerticalAlignTopOutlined = _resolveComponent("VerticalAlignTopOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "portal-home-project-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.goProject(_ctx.projectData.projectVo.project, _ctx.projectData.userProjectRel)
        ))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "portal-home-project-icon",
            style: _normalizeStyle({
              backgroundColor:
                _ctx.projectData.projectVo.config.styleConfig.themeColor
            })
          }, [
            _createVNode(_component_CloudServerOutlined)
          ], 4),
          _createElementVNode("div", {
            class: "portal-home-project-name",
            style: _normalizeStyle({
              cursor:
                _ctx.projectData.userProjectRel.userStatus === 'FROZEN' ||
                _ctx.projectData.projectVo.project.projectStatus !== 'IN_PROGRESS'
                  ? 'not-allowed'
                  : 'pointer'
            })
          }, _toDisplayString(_ctx.projectData.projectVo.project.projectName), 5),
          _createVNode(_component_HomeStatus, {
            class: "portal-home-project-state",
            status: _ctx.projectData.projectVo.project.projectStatus
          }, null, 8, ["status"]),
          (_ctx.projectData.top)
            ? (_openBlock(), _createBlock(_component_HomeStatus, {
                key: 0,
                class: "portal-home-project-state",
                status: "TOP"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "go-btn-part",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.goProject(_ctx.projectData.projectVo.project, _ctx.projectData.userProjectRel)
          ))
        }, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "btn",
            disabled: 
              _ctx.projectData.userProjectRel.userStatus === 'FROZEN' ||
                _ctx.projectData.projectVo.project.projectStatus !== 'IN_PROGRESS'
            
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ImportOutlined),
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", {
          class: "top-btn-part",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
            _ctx.projectData.top
              ? _ctx.cancelProjectTop(_ctx.projectData.projectVo.project.id)
              : _ctx.setProjectTop(_ctx.projectData.projectVo.project.id)
          ))
        }, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "top btn",
            disabled: 
              _ctx.projectData.userProjectRel.userStatus === 'FROZEN' ||
                _ctx.projectData.projectVo.project.projectStatus !== 'IN_PROGRESS'
            
          }, {
            default: _withCtx(() => [
              (!_ctx.projectData.top)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_VerticalAlignTopOutlined),
                    _hoisted_6
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_CloseOutlined),
                    _hoisted_7
                  ], 64))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}